import { createModal } from '/@/core/elements/modal'
import { type Client } from '/@/common/clients/types'

export interface CreateInvoiceModal {
  client: Pick<Client, 'id' | 'firstName' | 'lastName' | 'email'> | null
  serviceId?: string | null
  amountCents?: number | null
  description?: string | null
  onSubmit:
    | ((client: Pick<Client, 'firstName' | 'lastName' | 'email'>) => void)
    | null
}

const { api, component } = createModal<CreateInvoiceModal>(
  'CreateInvoiceModal',
  () => import('./CreateInvoiceModal.vue'),
  {
    client: null,
    onSubmit: null,
  },
)

export const useCreateInvoiceModal = api
export default component
